//scss
import "./assets/scss/socialv.scss"
import './assets/scss/custom.scss'
import "./assets/scss/customizer.scss"
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import "choices.js/public/assets/styles/choices.min.css";
import "flatpickr/dist/flatpickr.css";
import { ToastContainer } from 'react-toastify';


// Redux Selector / Action
import { useDispatch } from 'react-redux';

// import state selectors
import { setSetting } from './store/setting/actions'
import "./assets/custom/scss/socialv-custom.scss"
import InactivityHandler from "./components/InactivityHandler"
import { UploadProvider } from './contexts/UploadContext';
import UploadNotification from './components/UploadNotification';
import { useCallback } from 'react';
import Index from './views/upload_documents';

function App({ children }) {
  const dispatch = useDispatch()
  dispatch(setSetting())

  // Função para atualizar a tabela de documentos
  const handleDocumentCompleted = useCallback(() => {
    // Dispara o evento para atualizar a tabela
    const evt = new CustomEvent('refreshDocuments');
    window.dispatchEvent(evt);
  }, []);

  return (
    <UploadProvider onDocumentCompleted={handleDocumentCompleted}>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      <div className="App">
        <ToastContainer />
        <InactivityHandler />
        <UploadNotification />
        {/* <IndexRouters /> */}
        {children}
      </div>
    </UploadProvider>
  );
}

export default App;
